import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { browserHistory } from 'react-router'
import styles from './Routes.scss'
import { EmptyRoutes } from './EmptyRoutes'
import * as Filters from '../shared/filters'
import { RowCheckbox } from '../shared/RowCheckbox'
import { troutesMessages } from '../shared/intlMessages'
import { TRouteAccordian, TRouteListItemExpandable } from '../shared/TRouteAccordian'
import { RouteCondensedStats } from './RouteCondensedStats'
import { LoadableExpandedRoutePreview } from './ExpandedRoutePreview'
import cardStyles from 'common/SearchableCard/SearchableCard.scss'
import { SearchableCardMulti, SearchableCardInput, SearchableCardLocationInput } from 'common/SearchableCardMulti'
import { Card } from 'common/styleguide/Card'
import { Loadable } from 'common/Loadable'
import { PopoverFilter, FilterButton } from 'common/PopoverFilter'
import popoverFilterStyles from 'common/PopoverFilter/PopoverFilter.scss'
import { withMetricUnits } from 'common/units/MetricUnitsContext'
import { Chip } from 'common/styleguide/Chip'
import { CTA } from 'common/styleguide/CTA'
import { CircleSpinner } from 'common/spinners/CircleSpinner'
import { PopoverMenuItem, PopoverMenuHeading } from 'common/styleguide/PopoverMenu'
import { RadioGroup } from 'common/styleguide/RadioGroup'
import { Icon } from 'common/Icon'
import popoverMenuStyles from 'common/styleguide/PopoverMenu/PopoverMenu.scss'
import { IntroWidget } from 'common/IntroWidget'
import { ColWrap, MainCol } from 'common/layouts/SideNavLayout/TwoCol'
import { MobileCollapse } from 'common/layouts/SideNavLayout/SideNavContexts'
import { DeleteTRoutes, DELETE_TROUTES_DIALOG } from 'common/dialogs/DeleteTRoute'
import { ArchiveRoutes, UnarchiveRoutes, ARCHIVE_ROUTES_DIALOG, UNARCHIVE_ROUTES_DIALOG } from 'common/dialogs/ArchiveRoute'
import { Checkbox } from 'common/styleguide/Checkbox'
import { IeNudgeBar } from 'common/IeNudgeBar'
import { withSelect } from 'common/WithSelectable'
import { currentUserHasPrivilege } from 'lib/utils'
import * as userActions from 'lib/api/currentUser'
import * as favoritesActions from 'lib/api/favorites'
import * as routesActions from 'lib/api/routes'
import { apiv3 } from 'lib/apiv3'
import { findAsYouType } from 'lib/findAsYouType'
import { DEFAULT_OFFSET, DEFAULT_PER_PAGE, MAX_PER_PAGE } from 'lib/loadAllPages'
import * as L from 'lib/localization'
import { unitMessages } from 'lib/units/unitTypes'
import { Route } from 'data/records'
import { spoofV3ResourceExtras } from 'data/helpers/spoofActionCreator'
import { routeSelectors as routeResourceSelectors } from 'data/resources/routes'
import { collectionActions } from 'data/resources/collections'
import { collectionItemActions } from 'data/resources/collectionItems'
import Helmet from 'react-helmet'
import { OrderedMap, Map, Set } from 'immutable'
import cx from 'classnames'
import _ from 'lodash'
import { FormattedMessage as T, injectIntl } from 'react-intl'

const sortBySearchOpts = {
  created: 'created',
  updated: 'updated',
  name: 'name',
  distance: 'length',
  eleGain: 'elevation'
}

const sortByMenuOpts = intl => OrderedMap({
  created: L.fm(intl, L.commonMetrics.createdOn),
  updated: L.fm(intl, L.commonMetrics.updatedOn),
  name: _.startCase(L.fm(intl, L.commonNouns.name)),
  distance: L.fm(intl, L.commonMetrics.distance),
  eleGain: _.startCase(L.fm(intl, L.commonMetrics.elevationGain))
})

const sortDirMenuOpts = intl => OrderedMap({
  'ASC': L.fm(intl, L.commonMessages.asc),
  'DESC': L.fm(intl, L.commonMessages.desc)
})

const imperialRadiusMenuOpts = intl => OrderedMap({
  '1': `1 ${L.fm(intl, L.commonUnits.miles, { count: 1 })}`,
  '5': `5 ${L.fm(intl, L.commonUnits.miles, { count: 0 })}`,
  '10': `10 ${L.fm(intl, L.commonUnits.miles, { count: 0 })}`,
  '25': `25 ${L.fm(intl, L.commonUnits.miles, { count: 0 })}`,
  '50': `50 ${L.fm(intl, L.commonUnits.miles, { count: 0 })}`,
  '100': `100 ${L.fm(intl, L.commonUnits.miles, { count: 0 })}`,
  '250': `250 ${L.fm(intl, L.commonUnits.miles, { count: 0 })}`
})

const metricRadiusMenuOpts = intl => OrderedMap({
  '5': `5 ${L.fm(intl, L.commonUnits.kilometers, { count: 0 })}`,
  '10': `10 ${L.fm(intl, L.commonUnits.kilometers, { count: 0 })}`,
  '25': `25 ${L.fm(intl, L.commonUnits.kilometers, { count: 0 })}`,
  '50': `50 ${L.fm(intl, L.commonUnits.kilometers, { count: 0 })}`,
  '100': `100 ${L.fm(intl, L.commonUnits.kilometers, { count: 0 })}`,
  '250': `250 ${L.fm(intl, L.commonUnits.kilometers, { count: 0 })}`,
  '500': `500 ${L.fm(intl, L.commonUnits.kilometers, { count: 0 })}`
})

const privacyOptions = intl => OrderedMap({
  public: L.fm(intl, L.privacyLevels.public),
  friendsOnly: L.fm(intl, L.privacyLevels.friendsOnly),
  private: L.fm(intl, L.privacyLevels.private)
})

const startPageOptions = {
  offset: DEFAULT_OFFSET,
  limit: DEFAULT_PER_PAGE,
  loadMoreClicked: false
}

export class _Routes extends React.PureComponent {
  constructor (props) {
    super(props)
    const { loadableResources: initialResults } = props

    this.state = Object.assign({
      searchParams: {
        searchKeywords: '',
        locationKeywords: '',
        sortBy: 'created',
        sortDir: 'DESC',
        radius: '10',
        filters: Map()
      },
      initialResults,
      search: initialResults,
      searchPending: false,
      selectAllChecked: false,
      dialog: null
    }, startPageOptions)
    this._findAsYouType = findAsYouType({
      searchFn: this.executeSearch,
      onResults: this.onResults,
      throttle: 0
    })
    this._debouncedFindAsYouType = _.debounce(this._findAsYouType, 350)
  }

  componentDidMount () {
    const historyState = browserHistory.getCurrentLocation().state
    if (historyState) {
      const searchParams = { ...historyState }
      if (searchParams.filters.privacy) {
        searchParams.filters.privacy = Set(searchParams.filters.privacy)
      }
      searchParams.filters = Map(searchParams.filters)
      this.newSearch(searchParams, this._findAsYouType)
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const { search, selectAllChecked, searchPending } = this.state
    const { results } = search

    const aSearchJustCompleted = prevState.searchPending && !searchPending
    if (!prevState.selectAllChecked && selectAllChecked && !aSearchJustCompleted) {
      this.props.selectItems(results.map((t) => t.id))
    }
    if (prevState.selectAllChecked && !selectAllChecked && !aSearchJustCompleted) {
      this.props.clearSelection()
    }
  }

  newSearch = (newSearchParams, callback) => {
    const searchParams = { ...this.state.searchParams, ...newSearchParams }
    this.setState(Object.assign({}, startPageOptions, { searchParams }, { searchPending: true, selectAllChecked: false }),
      () => {
        this.props.clearSelection()
        callback()
      }
    )
  }

  onSearchKeywordChange = (e) => {
    const searchKeywords = e.target.value
    this.newSearch({ searchKeywords }, this._debouncedFindAsYouType)
  }

  onLocationKeywordChange = (e) => {
    const locationKeywords = e.target.value
    this.newSearch({ locationKeywords }, this._debouncedFindAsYouType)
  }

  onSortByChange = (e) => {
    this.newSearch({ sortBy: e }, this._findAsYouType)
  }

  onHasCuesheetClicked = (e) => {
    e.stopPropagation()
    const { filters } = this.state.searchParams

    if (filters.get('hasCuesheet')) {
      this.clearFilter('hasCuesheet')
    } else {
      this.setFilter('hasCuesheet', true)
    }
  }

  onArchivedClicked = (e) => {
    e.stopPropagation()
    const { filters } = this.state.searchParams

    if (filters.get('archived')) {
      this.clearFilter('archived')
    } else {
      this.setFilter('archived', true)
    }
  }

  onSortDirChange = (sortDir) => {
    this.newSearch({ sortDir }, this._findAsYouType)
  }

  toggleSelectAll = () => {
    this.setState((state) => ({ selectAllChecked: !state.selectAllChecked }))
  }

  onRadiusChange = (radius) => (this.newSearch({ radius }, this._findAsYouType))

  executeSearch = (extraCriteria = {}) => {
    const { currentUser } = this.props
    const {
      searchParams: {
        searchKeywords,
        locationKeywords,
        sortBy,
        sortDir,
        radius,
        filters
      },
      offset,
      limit
    } = this.state

    // note - the search endpoint does unit conversion automatically, on
    // the backend, based off the user's metric_units preference. There
    // isn't any way to override this, we just have to make sure that
    // we display 'km' and 'meter' labels for users that have metricUnits=t
    // and imperial labels for users that don't, and then hand off the
    // user input untouched to the search function
    return apiv3.routes.search({
      keywords: searchKeywords,
      offset: offset,
      limit: limit,
      userId: currentUser.id,
      sortBy: `${sortBySearchOpts[sortBy]} ${sortDir}`,
      startLocation: locationKeywords,
      radius: radius,
      ...filters.toJS(),
      ...extraCriteria
    })
  }

  isDefaultSearch = () => {
    const { searchParams } = this.state
    return (!searchParams.searchKeywords) &&
    (!searchParams.locationKeywords) &&
    (searchParams.filters.size === 0) &&
    (searchParams.sortBy === 'created') &&
    (searchParams.sortDir === 'DESC') &&
    (searchParams.radius === '10') &&
    (this.state.offset === startPageOptions['offset']) &&
    (this.state.limit === startPageOptions['limit'])
  }

  onResults = (nextSearch) => {
    const { spoofRoutes } = this.props
    const { searchParams } = this.state

    spoofRoutes(nextSearch.rawResults)
    browserHistory.replace({ ...browserHistory.getCurrentLocation(), state: { ...searchParams, filters: searchParams.filters.toJS() } })

    if (nextSearch.params.mergeResults) {
      this.setState((prevState) => {
        const combinedResults = _.concat(prevState.search.results, nextSearch.results)
        return {
          search: Object.assign({}, prevState.search, { results: combinedResults }),
          searchPending: false
        }
      })
    } else {
      this.setState({
        search: nextSearch,
        searchPending: false
      })
    }
  }

  setFilter = (filterKey, filterValue) => {
    this.newSearch({
      filters: this.state.searchParams.filters.set(filterKey, filterValue)
    }, this._findAsYouType)
  }

  clearFilter = (filterKey) => {
    this.newSearch({
      filters: this.state.searchParams.filters.remove(filterKey)
    }, this._findAsYouType)
  }

  // like clearFilter, but takes an array
  clearFilters = (filterKeys) => {
    const { filters } = this.state.searchParams
    const newFilters = filters

    this.newSearch({
      filters: newFilters.withMutations(nf => filterKeys.forEach(f => nf.remove(f)))
    }, this._findAsYouType)
  }

  getSelectedItems = () => {
    const { selectedItems } = this.props
    const { search } = this.state
    const { results } = search

    // Just to be double-sure that only items currently displayed can be selected
    return results.filter((t) => selectedItems.has(t.id))
  }

  setPrivacy = (privacy) => {
    const { clearSelection, batchSetVisibility } = this.props
    const { search } = this.state
    const { results } = search

    const selection = this.getSelectedItems()
    const selectedIds = Set(selection.map(t => t.id))

    batchSetVisibility(selectedIds, privacy).then(() => {
      // I'm just going to update the values in local state until we do the full on reducer thing later
      const newResults = results.map((t) => {
        if (selectedIds.has(t.id)) {
          return t.set('visibility', parseInt(privacy, 10))
        }
        return t
      })
      this.setState({ search: Object.assign({}, search, { results: newResults }) })

      clearSelection()
    })
  }

  addToCollections (collectionIds) {
    const { batchAddCollectionItems } = this.props
    const selectedIds = this.getSelectedItems().map(t => t.id)

    return Promise.all(
      collectionIds.map(cid => (
        batchAddCollectionItems({
          collectionId: cid,
          items: selectedIds.map(id => ({ item_type: 'Route', item_id: id }))
        })
      ))
    )
  }

  deleteRoutes = () => {
    const { clearSelection, batchDelete } = this.props
    const { search } = this.state
    const { results } = search

    const selectedIds = Set(this.getSelectedItems().map(t => t.id))

    return batchDelete(selectedIds).then(() => {
      const newResults = results.filter((t) => !selectedIds.has(t.id))

      this.setState({ search: Object.assign({}, search, { results: newResults }), dialog: null })

      clearSelection()
    })
  }

  toggleArchiveRoutes (archive) {
    const { clearSelection, batchArchive, batchUnarchive } = this.props
    const { search } = this.state
    const { results } = search

    const selectedIds = Set(this.getSelectedItems().map(t => t.id))

    return (archive ? batchArchive : batchUnarchive)(selectedIds).then(() => {
      const newResults = results.filter((t) => !selectedIds.has(t.id))

      this.setState({ search: Object.assign({}, search, { results: newResults, results_count: search.results_count - selectedIds.size }), dialog: null })

      clearSelection()
    })
  }

  archiveRoutes = () => {
    return this.toggleArchiveRoutes(true)
  }

  unarchiveRoutes = () => {
    return this.toggleArchiveRoutes(false)
  }

  toggleSort = () => {
    this.setState({ showSort: !this.state.showSort })
  }

  loadMore = () => {
    const { loadMoreClicked } = this.state
    this.setState((prevState) => ({
      searchPending: true,
      offset: prevState.offset + prevState.limit,
      limit: MAX_PER_PAGE
    }), () => this._findAsYouType({ mergeResults: !!loadMoreClicked }))

    // merge results next time we click loadMore
    this.setState({ loadMoreClicked: true })
  }

  showDialog = (dialog) => {
    this.setState({ dialog })
  }

  hideDialog = () => {
    this.setState({ dialog: null })
  }

  render () {
    const {
      currentUser,
      setPreference,
      selectedItems,
      selectItem,
      deselectItem,
      findRoute,
      intl
    } = this.props
    const {
      search,
      initialResults,
      searchParams: {
        searchKeywords,
        locationKeywords,
        sortBy,
        sortDir,
        radius,
        filters
      },
      offset,
      limit,
      searchPending,
      selectAllChecked,
      dialog
    } = this.state
    const { results } = search

    if (search === initialResults && results.length === 0 && !search.has_archived) {
      return <EmptyRoutes />
    }

    const showSelects = currentUserHasPrivilege('route_management')
    const showSelectionToolbar = selectedItems.size > 0

    return (
      <Fragment>
        {dialog === DELETE_TROUTES_DIALOG &&
          <DeleteTRoutes
            troutes={this.getSelectedItems()}
            onConfirm={this.deleteRoutes}
            onRequestClose={this.hideDialog} />}
        {dialog === ARCHIVE_ROUTES_DIALOG &&
          <ArchiveRoutes
            routes={this.getSelectedItems()}
            onConfirm={this.archiveRoutes}
            onRequestClose={this.hideDialog} />}
        {dialog === UNARCHIVE_ROUTES_DIALOG &&
          <UnarchiveRoutes
            routes={this.getSelectedItems()}
            onConfirm={this.unarchiveRoutes}
            onRequestClose={this.hideDialog} />}
        <IeNudgeBar currentUser={currentUser} setPreference={setPreference} />
        <ColWrap className={styles.earlyCollapse}>
          <Helmet title={`${L.fm(intl, L.featureNames.routes)} · Ride with GPS`} />
          <MainCol>
            <h2 data-heading-alt>{L.fm(intl, L.featureNames.routes)}</h2>
            <div className={styles.filters}>
              {showSelects && <MobileCollapse><FilterButton>
                <input type='checkbox' onChange={this.toggleSelectAll} checked={selectAllChecked} />
              </FilterButton></MobileCollapse>}
              {showSelectionToolbar && <Fragment>
                <PopoverFilter
                  intl={intl}
                  label={L.fm(intl, Filters.setPrivacyMenuMessages.setPrivacy)}>
                  {({ toggleExpand }) => <Filters.SetPrivacyMenu
                    onApply={(privacy) => { toggleExpand(); this.setPrivacy(privacy) }} />}
                </PopoverFilter>
                <PopoverFilter
                  intl={intl}
                  label={L.fm(intl, troutesMessages.addToCollection)}>
                  {({ toggleExpand }) => <Filters.AddToCollectionMenu
                    userId={currentUser.id}
                    toggleExpand={() => toggleExpand()}
                    troutes={this.getSelectedItems()}
                    objectType='Route'
                    onApply={(collections) => { toggleExpand(this.addToCollections(collections)) }} />}
                </PopoverFilter>
                {!filters.get('archived') &&
                  <FilterButton onClick={() => this.showDialog(ARCHIVE_ROUTES_DIALOG)} valignCenter>
                    <T id='Routes.archive' defaultMessage='Archive' />
                  </FilterButton>}
                {filters.get('archived') &&
                  <FilterButton onClick={() => this.showDialog(UNARCHIVE_ROUTES_DIALOG)} valignCenter>
                    <T id='Routes.unarchive' defaultMessage='Unarchive' />
                  </FilterButton>}
                <FilterButton onClick={() => this.showDialog(DELETE_TROUTES_DIALOG)} valignCenter>
                  <Icon i='md-trash' style={{ color: '#757575' }} size={20} /> <L.Msg m={L.commonVerbs.delete} />
                </FilterButton>
              </Fragment>}
              {!showSelectionToolbar && <Fragment>
                <PopoverFilter
                  intl={intl}
                  label={L.fm(intl, L.commonMetrics.distance)}>
                  {({ toggleExpand }) => <Filters.LengthInput
                    defaultValue={filters.get('length')}
                    onApply={length => { this.setFilter('length', length) }}
                    onClear={() => { toggleExpand(); this.clearFilter('length') }} />}
                </PopoverFilter>
                <PopoverFilter
                  intl={intl}
                  label={_.startCase(L.fm(intl, L.commonMetrics.elevationGain))}>
                  {({ toggleExpand }) => <Filters.ElevationInput
                    defaultValue={filters.get('elevation')}
                    onApply={elevation => { this.setFilter('elevation', elevation) }}
                    onClear={() => { toggleExpand(); this.clearFilter('elevation') }} />}
                </PopoverFilter>
                <PopoverFilter
                  intl={intl}
                  label={L.fm(intl, L.commonMetrics.createdOn)}>
                  {({ toggleExpand }) => <Filters.DateInput
                    currentUser={currentUser}
                    value={filters.get('createdOn')}
                    defaultValue={filters.get('createdOn')}
                    onApply={createdOn => { this.setFilter('createdOn', createdOn) }}
                    onClear={() => { toggleExpand(); this.clearFilter('createdOn') }} />}
                </PopoverFilter>
                <PopoverFilter
                  intl={intl}
                  label={L.fm(intl, L.commonMetrics.updatedOn)}>
                  {({ toggleExpand }) => <Filters.DateInput
                    currentUser={currentUser}
                    value={filters.get('updatedOn')}
                    defaultValue={filters.get('updatedOn')}
                    onApply={updatedOn => { this.setFilter('updatedOn', updatedOn) }}
                    onClear={() => { toggleExpand(); this.clearFilter('updatedOn') }} />}
                </PopoverFilter>
                <PopoverFilter
                  intl={intl}
                  label={L.fm(intl, L.commonNouns.options)}>
                  {({ toggleExpand }) => <Fragment>
                    <Checkbox
                      horizontal
                      onChange={e => this.onHasCuesheetClicked(e)}
                      checked={!!filters.get('hasCuesheet')}
                      label={L.fm(intl, L.commonTRouteMessages.hasCuesheet)} />
                    <Checkbox
                      horizontal
                      className={styles.lastOption}
                      onChange={e => this.onArchivedClicked(e)}
                      checked={!!filters.get('archived')}
                      label={L.fm(intl, troutesMessages.archived)} />
                    <div className={popoverFilterStyles.innerLabel}><L.Msg m={L.privacyLevels.privacy} />:</div>
                    <Filters.CheckboxInput
                      options={privacyOptions(intl)}
                      defaultValue={filters.get('privacy')}
                      onApply={privacy => { this.setFilter('privacy', privacy) }}
                      onClear={() => { toggleExpand(); this.clearFilters(['hasCuesheet', 'archived', 'privacy']) }} />
                  </Fragment>}
                </PopoverFilter>
              </Fragment>}
              <PopoverFilter
                label={`${L.fm(intl, troutesMessages.sortBy)}: ${sortByMenuOpts(intl).get(sortBy)}`}
                hidePopoverLabel
                noPadding
                intl={intl}
                className={cx(styles.filterRight, styles.specificityHack)}
                icon={<Icon i={`mdi-sort-${sortDir === 'ASC' ? 'ascending' : 'descending'}`} />}>
                <ul className={popoverMenuStyles.PopoverMenu}>
                  <PopoverMenuHeading><L.Msg m={troutesMessages.sortOptions} /></PopoverMenuHeading>
                  <PopoverMenuItem>
                    <RadioGroup
                      style={{ margin: '0 0' }}
                      horizontal
                      options={sortByMenuOpts(intl)}
                      selected={sortBy}
                      radioClass={styles.radioClass}
                      onChange={this.onSortByChange} />
                  </PopoverMenuItem>
                  <PopoverMenuHeading><L.Msg m={troutesMessages.sortOrder} /></PopoverMenuHeading>
                  <PopoverMenuItem>
                    <RadioGroup
                      style={{ margin: '0 0' }}
                      horizontal
                      options={sortDirMenuOpts(intl)}
                      selected={sortDir}
                      radioClass={styles.radioClass}
                      onChange={this.onSortDirChange} />
                  </PopoverMenuItem>
                </ul>
              </PopoverFilter>
            </div>

            <Card noPadding>
              <SearchableCardMulti
                inputs={[
                  <SearchableCardInput
                    key='keyword'
                    placeholder={L.fm(intl, troutesMessages.keyword)}
                    onKeywordChange={this.onSearchKeywordChange}
                    keywords={searchKeywords} />,
                  <UnitAwareSearchableCardLocationInput
                    intl={intl}
                    key='location'
                    placeholder={L.fm(intl, troutesMessages.startLocation)}
                    onKeywordChange={this.onLocationKeywordChange}
                    keywords={locationKeywords}
                    radius={radius}
                    onRadiusChange={this.onRadiusChange} />
                ]}
                resultsLength={results.length}
                resultsCount={!this.isDefaultSearch() ? search.results_count : undefined}
                chips={filters.size > 0 && filters.map((v, k) => <FilterCard key={k} type={k} value={v} onDismiss={() => this.clearFilter(k)} />).valueSeq()}>
                <Results
                  results={results}
                  executeSearch={this.executeSearch}
                  currentUser={currentUser}
                  onResults={this.onResults}
                  showSelects={showSelects}
                  selectedItems={selectedItems}
                  selectItem={selectItem}
                  deselectItem={deselectItem}
                  findRoute={findRoute}
                  accordianProps={{
                    deleteTRoute: this.props.deleteRoute,
                    currentUser: currentUser,
                    pinned: this.props.pinned,
                    pin: this.props.pin,
                    unpin: this.props.unpin
                  }}
                />
                {search.results_count > results.length && search.results_count > limit &&
                <div className={cardStyles.resultsFooter}>
                  <CTA inline secondary margins={false} disabled={searchPending} onClick={() => !searchPending && this.loadMore()}>
                    {searchPending && <CircleSpinner size={14} />} <L.Msg m={L.commonCTAs.loadMore} />
                  </CTA>
                  <div style={{ paddingTop: '20px' }}>
                    <span className={cardStyles.footerText}>
                      <L.Msg m={L.commonMessages.showingResults} values={{ length: results.length, totalCount: search.results_count }} />
                    </span>
                  </div>
                </div>}
                {!searchPending &&
                  search.results_count > startPageOptions.limit &&
                  (offset + limit) >= search.results_count &&
                  results.length === search.results_count &&
                  <div className={cardStyles.resultsFooter}>
                    <span className={cardStyles.footerText}><L.Msg m={L.commonMessages.noMoreItems} /></span>
                  </div>}
                {results.length === 0 && <IntroWidget large i='md-bicycle'>
                  <L.Msg m={troutesMessages.noneFound} values={{ types: L.fm(intl, L.commonNouns.routes, { count: 2 }) }} />
                </IntroWidget>}
              </SearchableCardMulti>
            </Card>
          </MainCol>
        </ColWrap>
      </Fragment>
    )
  }
}

class _Results extends React.Component {
  shouldComponentUpdate (nextProps) {
    return nextProps.results !== this.props.results || nextProps.selectedItems !== this.props.selectedItems
  }

  render () {
    const {
      results,
      executeSearch,
      onResults,
      showSelects,
      selectedItems,
      selectItem,
      deselectItem,
      accordianProps,
      findRoute,
      metricUnits
    } = this.props

    const ids = results.map((r) => r.id)

    return (
      <TRouteAccordian {...accordianProps}>
        {ids.map(id => {
          const route = findRoute(id)
          return route && <TRouteListItemExpandable
            condensedComponent={RouteCondensedStats}
            previewComponent={LoadableExpandedRoutePreview}
            key={id}
            metricUnits={metricUnits}
            troute={route}
            expandKey={id}
            executeSearch={executeSearch}
            onResults={onResults}
            checkbox={showSelects &&
              <RowCheckbox
                onChange={() => selectedItems.has(id)
                  ? deselectItem(id)
                  : selectItem(id)}
                checked={selectedItems.has(id)} />
            } />
        }).filter(x => x)}
      </TRouteAccordian>
    )
  }
}

const Results = withMetricUnits(_Results)

const UnitAwareSearchableCardLocationInput = withMetricUnits(({ metricUnits, ...props }) => (
  <SearchableCardLocationInput
    radiusMenuOpts={metricUnits ? metricRadiusMenuOpts(props.intl) : imperialRadiusMenuOpts(props.intl)}
    {...props} />
))

const FilterCard = injectIntl(withMetricUnits(({ type, value, metricUnits, onDismiss, intl }) => {
  const distanceUnits = L.fm(intl, metricUnits ? unitMessages.kmShort : unitMessages.miShort)
  const eleUnits = L.fm(intl, metricUnits ? unitMessages.mShort : unitMessages.ftShort)

  switch (type) {
    case 'length':
      return <Chip onDismiss={onDismiss}><L.Msg m={L.commonMetrics.distance} />: {Filters.formatRangeLabel({ ...value, unitLabel: distanceUnits, metricType: 'distance' })}</Chip>
    case 'elevation':
      return <Chip onDismiss={onDismiss}><L.Msg m={L.commonMetrics.elevation} />: {Filters.formatRangeLabel({ ...value, unitLabel: eleUnits, metricType: 'distance' })}</Chip>
    case 'privacy':
      return <Chip onDismiss={onDismiss}><L.Msg m={L.privacyLevels.privacy} />: {Filters.formatCheckboxLabel(value, privacyOptions(intl))}</Chip>
    case 'createdOn':
      return <Chip onDismiss={onDismiss}><L.Msg m={troutesMessages.created} />: {Filters.formatDateRangeLabel(value.min, value.max)}</Chip>
    case 'updatedOn':
      return <Chip onDismiss={onDismiss}><L.Msg m={troutesMessages.updated} />: {Filters.formatDateRangeLabel(value.min, value.max)}</Chip>
    case 'hasCuesheet':
      return <Chip onDismiss={onDismiss}><L.Msg m={L.commonTRouteMessages.hasCuesheet} /></Chip>
    case 'archived':
      return <Chip onDismiss={onDismiss}><L.Msg m={troutesMessages.archived} /></Chip>
    default:
      console.warn(`encountered unknown filter type ${type}`)
      return null
  }
}))

const doInitialSearch = (currentUser) => (
  apiv3.routes.search({
    limit: DEFAULT_PER_PAGE,
    userId: currentUser.id,
    sortBy: 'departed_or_created DESC'
  })
)

export const Routes = injectIntl(withSelect(_Routes))

const LoadableRoutes = (props) => {
  return <Loadable
    {...props}
    component={Routes}
    loadingText={<T id='Routes.loadableMessage' defaultMessage='Loading your routes' />}
    resourceLoaded={() => {
      props.loadCollections(props.currentUser.id)
      return doInitialSearch(props.currentUser)
        .then((resp) => {
          props.spoofRoutes(resp.rawResults)
          return resp
        })
    }} />
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.currentUser,
    pinned: (id) => !!state.favorites.getIn(['favoritesByType', 'route', id]),
    findRoute: (id) => {
      return routeResourceSelectors.find(state, id)
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  const actionCreators = {
    deleteRoute: routesActions.deleteRoute,
    batchSetVisibility: routesActions.batchSetVisibility,
    batchDelete: routesActions.batchDelete,
    batchArchive: routesActions.batchArchive,
    batchUnarchive: routesActions.batchUnarchive,
    pin: favoritesActions.pin,
    unpin: favoritesActions.unpin,
    setPreference: userActions.setPreference,
    loadCollections: collectionActions.list,
    batchAddCollectionItems: collectionItemActions.batchAdd
  }

  return {
    ...bindActionCreators(actionCreators, dispatch),
    spoofRoutes: (extras) => dispatch(spoofV3ResourceExtras(extras, [Route]))
  }
}

export const RoutesContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadableRoutes)
